"use client";
import CookieConsentProvider from "@/context/ConsentContext";
export default function CookieConsentProviderClient({ children }) {
  return <CookieConsentProvider>{children}</CookieConsentProvider>;
}
